module.exports = __webpack_public_path__ + "static/media/logo.76ddc4a9.png";